import React from 'react';

const Service = ({service}) => {
    const { name, description, image } = service;
    return (
        <div >
            <div className="card w-auto  shadow-xl">

                <figure className="px-10 pt-10">
                    <img src={image} alt="Shoes" className="rounded-xl" />
                </figure>
                <div className="card-body items-center text-center">
                    <h2 className="card-title">{name}</h2>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    );
};

export default Service;